import { createApp } from 'vue'
import App from './App.vue'
import installElementPlus from './plugins/element'
import router from './router'
import '@/assets/reset.css'
import ElementPlus from 'element-plus';
import './assets/iconfont/iconfont.css'
import { getToken } from './utils/auth'

router.beforeEach((to, from, next) => {
  document.title = '鹏天助学';
  const token = getToken() 
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath } 
      });
    } else {
      next();
    }
  } else {
    if (to.path === '/login' && token) {
      next('/');
    } else {
      next();
    }
  }
});

const app = createApp(App).use(router)
installElementPlus(app)
app.use(router).use(ElementPlus)
app.mount('#app');